// extracted by mini-css-extract-plugin
export var form = "_e1-0";